import { Button, Modal, useNotify, Text, tokens } from '@hotjar/hotsauce';
import * as React from 'react';
import copy from 'copy-to-clipboard';
import { Trans, useTranslation } from '@hotjar/translations';
import styled from '@emotion/styled';
import type { PublicApiKeyCreateResponse } from '../../domains/public-api/types';

type Props = { newKey: PublicApiKeyCreateResponse | null; isOpen: boolean; onClose: () => void };

const S = {
  List: styled.ul`
    margin-top: ${tokens.spacer.x2};
  `,
};

export const NewApiKeyModal = ({ newKey, isOpen, onClose }: Props): JSX.Element => {
  const { t } = useTranslation('auth');
  const { showToast } = useNotify();

  const copyKey = () => {
    if (!newKey) return;
    copy(newKey.secret);
    showToast({
      text: t('public-api.new-key-modal.copy-success-toast'),
      kind: 'success',
    });
  };

  return (
    <Modal contentLabel={t('public-api.new-key-modal.title')} isOpen={isOpen} onClose={onClose}>
      <Modal.Header title={t('public-api.new-key-modal.title')} />
      <Modal.Body>
        <Text>
          <Trans i18nKey="auth:public-api.new-key-modal.info">
            label
            <strong>secret</strong>
          </Trans>
        </Text>
        <S.List>
          <li>
            <strong>{t('public-api.new-key-modal.key-name')}:</strong> {newKey?.displayName}
          </li>
          <li>
            <strong>{t('public-api.client-id')}:</strong> {newKey?.keyId}
          </li>
          <li>
            <strong>{t('public-api.new-key-modal.api-key')}:</strong> {newKey?.secret}
          </li>
        </S.List>
      </Modal.Body>
      <Modal.Footer>
        <Button icon="copy" kind="primary" onClick={copyKey}>
          {t('public-api.new-key-modal.copy-button')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
